/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.assessments.rpc.QuizAttemptService
 */

export const startRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.QuizAttemptService',
  rpcName: 'start',
  auth: 'app',
  fingerprint: 'XBQuJfMh89TK7x_KR8PC42am18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const finishRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.QuizAttemptService',
  rpcName: 'finish',
  auth: 'app',
  fingerprint: 'MssSymMGBdDK7x_KR8PC42am18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const checkQuestionRpc = {
  serviceName: 'com.hubspot.academy.assessments.rpc.QuizAttemptService',
  rpcName: 'checkQuestion',
  auth: 'app',
  fingerprint: 'ExVolDoVKim-XNri4BVXqGam18x0RSDB',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};